import { render, staticRenderFns } from "./mySalesBuyers.vue?vue&type=template&id=04d29f2d&scoped=true&lang=html&"
import script from "./mySalesBuyers.vue?vue&type=script&lang=js&"
export * from "./mySalesBuyers.vue?vue&type=script&lang=js&"
import style0 from "./mySalesBuyers.vue?vue&type=style&index=0&id=04d29f2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d29f2d",
  null
  
)

export default component.exports